// extracted by mini-css-extract-plugin
export default {"projectsContainer":"Statistics_projectsContainer__EOyBU"};